import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { componentDestroyed, handleError, LeagueNews, TournamentSeason, UntilDestroy } from '@mtgame/core';
import { LeagueVideoListService } from './league-video-list.service';
import { takeUntil } from 'rxjs/operators';
import { getLeagueNewsDetailRoute, getLeagueVideoDetailRoute } from '@config/routes';
import { LeagueRootService } from '@core/services/league-root.service';
import { UntypedFormControl } from '@angular/forms';
import { LoaderService, ToastService } from '@mtgame/ui';

@UntilDestroy
@Component({
  selector: 'mtg-league-video-list',
  templateUrl: './league-video-list.component.html',
  styleUrls: ['./league-video-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueVideoListComponent implements OnInit, OnDestroy {
  news: LeagueNews[];
  seasons: TournamentSeason[];
  seasonControl = new UntypedFormControl(null);

  constructor(
    private leagueVideoListService: LeagueVideoListService,
    private leagueRootService: LeagueRootService,
    private loaderService: LoaderService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.leagueVideoListService.news$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(news => {
        this.news = news;
        this.cdr.markForCheck();
      });
    this.seasons = this.leagueRootService.getActiveSeasonsModel();
    this.seasonControl.valueChanges.subscribe(async seasonId => {
      this.loaderService.show();
      try {
        await this.leagueVideoListService.setSeasonId(seasonId);
      } catch (e) {
        this.toastService.danger('Ошибка');
      } finally {
        this.loaderService.hide();
      }
    });
  }

  ngOnDestroy(): void {
    this.leagueVideoListService.dispose();
  }

  getVideoAbsoluteRoute(newsId: number): string {
    if (!window) {
      return '';
    }
    return `${window.location.origin}${getLeagueVideoDetailRoute(newsId).join('/')}`;
  }

  getVideoRoute(newsId: number): string[] {
    return getLeagueVideoDetailRoute(newsId);
  }

  async loadNextPage(): Promise<void> {
    try {
      await this.leagueVideoListService.loadNextPage();
    } catch (e) {
      handleError(e);
    }
  }

  get nextPageVisible(): boolean {
    return this.leagueVideoListService.page * this.leagueVideoListService.size < this.leagueVideoListService.total;
  }
}
